import {
  getSchema as getSchema1,
  uiSchema as uiSchema1,
} from "./schema.followUpPhone.1";

// eslint-disable-next-line import/no-default-export
export default (defaultValues?: { [key: string]: any }) => [
  { schema: getSchema1(defaultValues || {}), uiSchema: uiSchema1() },
];
